module.exports = __webpack_public_path__ + "ff5a82cf30b69ffddac8d70e4fe5407b.svg";